import {detect} from 'detect-browser';
import {getCookie, setCookie} from '../Utility/GlobalFunctions';

export function detectBrowser(): void {
  const browser = detect();

  const html = document.getElementsByTagName('html')[0];

  if (browser && browser.os && html) {
    html.classList.add(makeNiceString(browser.os.toString()));
    html.classList.add(makeNiceString(browser.name));
    html.classList.add(makeNiceString(browser.name) + '--' + makeNiceString(browser.version));
  }

  //in case browser is ie show a popup to suggest using another browser
  if (browser && browser.name === 'ie') {
    popupIe();
  }

  if (isTouchDevice()) {
    html.classList.add('touch');
  }
}

function makeNiceString(input: string): string {
  const output = input.toLowerCase().replace(' ', '-');
  if (output.indexOf('.') < 0) {
    return output;
  }
  return output.substr(0, output.indexOf('.'));
}

export function popupIe() {
  const cookieName = 'popup-ie';
  const cookieValue = 1;
  const popup = document.querySelector('.js-popup-ie');
  const closePopup = document.querySelector('.js-close-popup-ie');
  if (popup && closePopup) {
    closePopup.addEventListener('click', e => {
      setCookie(cookieName, cookieValue);
      popup.classList.add('hide');
    });
    if (!getCookie(cookieName)) {
      popup.classList.remove('hide');
    }
  }
}

export function isTouchDevice(): boolean {
  return (('ontouchstart' in window)
    || (navigator.maxTouchPoints > 0)
    || (navigator.msMaxTouchPoints > 0));
}
